module.exports = __webpack_public_path__ + "img/reactsaga.f90acb37.png";